var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');


function fireValidationTracking(input, success, creativeId){
    var sub = input + (success ? '_input_success':'_input_fail');
    eventToolbox.fireAction({
        'event_type': 'action_progress',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name':'lead_submission',
            'subaction_name':sub,
            'action_cause': 'user_input',
            'creative_id': creativeId
        }
    });
}

$(window.document).on('validation', function(e, data){
    var inputField = data.field[0].name;
    if(inputField === 'email' || inputField === 'phoneNumber'){
        inputField = inputField.replace('Number','');
        var success = data.value;
        var creativeId = data.field.closest('.edm-entry').attr('id');
        fireValidationTracking(inputField, success, creativeId);
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/validation-engagement-handler/validation-engagement-handler.js
// module id = 438
// module chunks = 36